import { AbstractStorageProvider } from "./AbstractStorageProvider.js";
class SyncedStorageProvider extends AbstractStorageProvider {
  childStore;
  constructor(store, childStore) {
    super(store);
    this.childStore = childStore;
  }
  async get(key) {
    const value = await this.store.get(key);
    if (this.childStore.get(key) !== value) {
      this.childStore.set(key, value);
    }
    return value;
  }
  async set(key, value) {
    this.store.set(key, value);
    this.childStore.set(key, value);
  }
  async has(key) {
    return this.store.has(key);
  }
  async delete(key) {
    this.store.delete(key);
    this.childStore.delete(key);
  }
}
export {
  SyncedStorageProvider
};
//# sourceMappingURL=SyncedStorageProvider.js.map
